import type { Specs, CapabilityConfig } from '@doxyme/extensions-common';
import type Instance from '../instance';

type Constraints = Specs.Constraints;
export default abstract class ExtensionRuntime {
  instance: Instance;

  readonly id: string;

  protected controller: AbortController | undefined;

  constructor(id: string, instance: Instance) {
    this.id = id;

    this.instance = instance;
  }

  static runtimeId(instance: Instance, config: CapabilityConfig): string {
    return `${instance.id}-${config['id'] as string}`; // cast is needed because config doesn't specify 'id' since it is added at runtime
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  destroy(): void {}

  setInstance(instance: Instance): void {
    this.instance = instance;
  }

  abstract notify(tuple: Constraints['eventPayloadTuple']): void;
}
